export const BUSINESS_PAGES = {
  students: {
    title: "学生管理中心",
    description: "管理学生档案、家长信息及班级状态",
    addText: "新增学生",
    addIcon: "el-icon-user-solid",
    exportable: true,
    selectable: true,
    filters: [
      {
        key: "keyword",
        label: "学生姓名",
        type: "input",
        placeholder: "输入姓名",
      },
      { key: "classId", label: "所在班级", type: "select", lookup: "classes" },
      {
        key: "status",
        label: "学生状态",
        type: "select",
        options: [
          { label: "在读", value: "active" },
          { label: "请假中", value: "leave" },
          { label: "停托", value: "suspended" },
          { label: "毕业", value: "graduated" },
        ],
      },
    ],
    columns: [
      { prop: "name", label: "学生姓名", avatar: true },
      { prop: "genderLabel", label: "性别", width: 70 },
      { prop: "grade", label: "年级" },
      { prop: "school", label: "就读学校" },
      { prop: "className", label: "当前班级", width: 140 },
      {
        prop: "remainingDaysLabel",
        label: "剩余天数",
        width: 100,
        remainingDays: true,
      },
      { prop: "lastCareReminderLabel", label: "催收通知", width: 150 },
      { prop: "pointsLabel", label: "积分", width: 90 },
      { prop: "guardian", label: "家长姓名" },
      { prop: "phone", label: "手机号", width: 130 },
      { prop: "statusLabel", label: "状态", status: true },
    ],
    form: [
      { key: "name", label: "学生姓名", required: true },
      {
        key: "gender",
        label: "性别",
        type: "select",
        options: [
          { label: "男", value: "male" },
          { label: "女", value: "female" },
        ],
      },
      {
        key: "grade",
        label: "年级",
        type: "select",
        options: ["一年级", "二年级", "三年级", "四年级", "五年级", "六年级"],
        required: true,
      },
      { key: "school", label: "就读学校" },
      { key: "classId", label: "班级", type: "select", lookup: "classes" },
      {
        key: "remainingDays",
        label: "初始剩余天数",
        type: "number",
        required: true,
      },
      { key: "guardian", label: "家长姓名" },
      { key: "phone", label: "家长手机号" },
    ],
    actionWidth: 430,
  },
  classes: {
    title: "班级管理",
    description: "管理班级容量、负责老师和今日出勤情况",
    addText: "新增班级",
    filters: [
      {
        key: "keyword",
        label: "班级名称",
        type: "input",
        placeholder: "输入班级名称",
      },
      {
        key: "teacherId",
        label: "负责老师",
        type: "select",
        lookup: "teachers",
      },
      {
        key: "status",
        label: "班级状态",
        type: "select",
        options: [
          { label: "正常", value: "active" },
          { label: "已停用", value: "disabled" },
        ],
      },
    ],
    form: [
      { key: "name", label: "班级名称", required: true },
      {
        key: "teacherIds",
        label: "负责老师",
        type: "multi-select",
        lookup: "teachers",
        required: true,
      },
      { key: "capacity", label: "班级容量", type: "number", required: true },
    ],
    classCards: true,
  },
  attendance: {
    title: "考勤记录",
    description: "查看学生接送状态及考勤记录",
    addText: "",
    exportable: true,
    filters: [
      {
        key: "date",
        label: "考勤日期",
        type: "date",
        required: true,
        defaultValue: () => {
          const date = new Date();
          date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
          return date.toISOString().slice(0, 10);
        },
      },
      { key: "classId", label: "班级", type: "select", lookup: "classes" },
      {
        key: "status",
        label: "考勤状态",
        type: "select",
        options: [
          { label: "已签到", value: "checked_in" },
          { label: "未签到", value: "not_arrived" },
          { label: "请假", value: "leave" },
        ],
      },
    ],
    columns: [
      { prop: "studentName", label: "学生姓名", avatar: true },
      { prop: "className", label: "班级", width: 150 },
      { prop: "statusLabel", label: "考勤状态", status: true },
      { prop: "checkIn", label: "签到时间" },
      { prop: "pickupPerson", label: "接送人" },
    ],
    form: [
      {
        key: "studentId",
        label: "学生",
        type: "select",
        lookup: "students",
        required: true,
      },
      { key: "date", label: "日期", type: "date", required: true },
      {
        key: "status",
        label: "考勤状态",
        type: "select",
        options: [
          { label: "已签到", value: "checked_in" },
          { label: "请假", value: "leave" },
        ],
      },
      { key: "remark", label: "备注", type: "textarea" },
    ],
    actionWidth: 0,
  },
  leaves: {
    title: "请假申请审批",
    description: "处理家长提交的请假申请，审批结果同步至考勤",
    addText: "新增请假",
    filters: [
      {
        key: "keyword",
        label: "学生姓名",
        type: "input",
        placeholder: "输入学生姓名",
      },
      { key: "classId", label: "班级", type: "select", lookup: "classes" },
      {
        key: "status",
        label: "审核状态",
        type: "select",
        options: [
          { label: "待审批", value: "pending" },
          { label: "已通过", value: "approved" },
          { label: "已拒绝", value: "rejected" },
        ],
      },
      { key: "date", label: "请假日期", type: "date" },
    ],
    columns: [
      { prop: "studentName", label: "学生姓名", avatar: true },
      { prop: "className", label: "班级" },
      { prop: "range", label: "请假时间", width: 180 },
      { prop: "type", label: "请假类型" },
      { prop: "reason", label: "请假原因", width: 180 },
      { prop: "statusLabel", label: "审批状态", status: true },
    ],
    form: [
      {
        key: "studentId",
        label: "学生",
        type: "select",
        lookup: "students",
        required: true,
      },
      {
        key: "type",
        label: "请假类型",
        type: "select",
        options: [
          { label: "病假", value: "sick" },
          { label: "事假", value: "personal" },
        ],
      },
      { key: "startDate", label: "开始日期", type: "date", required: true },
      { key: "endDate", label: "结束日期", type: "date", required: true },
      { key: "reason", label: "请假原因", type: "textarea" },
    ],
    actionWidth: 180,
  },
  feedbacks: {
    title: "作业反馈",
    description: "查看学生每日作业与离托评价",
    addText: "新增反馈",
    exportable: true,
    selectable: true,
    filters: [
      { key: "date", label: "日期", type: "date" },
      { key: "classId", label: "班级", type: "select", lookup: "classes" },
      {
        key: "published",
        label: "反馈状态",
        type: "select",
        options: [
          { label: "已反馈", value: true },
          { label: "待反馈", value: false },
        ],
      },
      {
        key: "keyword",
        label: "学生姓名",
        type: "input",
        placeholder: "输入学生姓名",
      },
    ],
    columns: [
      { prop: "studentName", label: "学生姓名", avatar: true },
      { prop: "className", label: "班级" },
      { prop: "date", label: "记录日期" },
      { prop: "disciplineLevel", label: "纪律" },
      { prop: "accuracy", label: "正确率" },
      { prop: "speed", label: "速度" },
      { prop: "handwriting", label: "字迹" },
      { prop: "homeworkRegistration", label: "作业登记" },
      { prop: "reviewExtension", label: "复习拓展" },
      { prop: "statusLabel", label: "反馈状态", status: true },
    ],
    form: [
      {
        key: "studentId",
        label: "学生",
        type: "select",
        lookup: "students",
        required: true,
      },
      { key: "date", label: "记录日期", type: "date", required: true },
      {
        key: "disciplineLevel",
        label: "纪律",
        type: "radio",
        options: ["良好", "一般", "较差"],
      },
      {
        key: "accuracy",
        label: "正确率",
        type: "radio",
        options: ["较高", "一般", "较差"],
      },
      {
        key: "speed",
        label: "速度",
        type: "radio",
        options: ["快速", "一般", "拖拉"],
      },
      {
        key: "handwriting",
        label: "字迹",
        type: "radio",
        options: ["整洁", "一般", "潦草"],
      },
      {
        key: "homeworkRegistration",
        label: "作业登记",
        type: "radio",
        options: ["有", "不全", "无"],
      },
      {
        key: "reviewExtension",
        label: "复习拓展",
        type: "radio",
        options: ["完成", "部分", "没做"],
      },
      { key: "comment", label: "老师评语", type: "textarea" },
    ],
  },
  notices: {
    title: "通知公告管理",
    description: "发布和维护机构、班级及缴费通知",
    addText: "发布通知",
    exportable: true,
    filters: [
      {
        key: "keyword",
        label: "公告标题",
        type: "input",
        placeholder: "输入公告标题",
      },
      {
        key: "type",
        label: "通知类型",
        type: "select",
        options: [
          { label: "机构公告", value: "organization" },
          { label: "班级通知", value: "class" },
          { label: "缴费通知", value: "payment" },
          { label: "放假通知", value: "holiday" },
        ],
      },
      {
        key: "status",
        label: "发布状态",
        type: "select",
        options: [
          { label: "草稿", value: "draft" },
          { label: "已发布", value: "published" },
          { label: "已撤回", value: "revoked" },
        ],
      },
      { key: "date", label: "发布日期", type: "date" },
    ],
    columns: [
      { prop: "title", label: "公告标题", width: 220 },
      { prop: "typeLabel", label: "类型" },
      { prop: "scopeLabel", label: "发布范围" },
      { prop: "read", label: "阅读情况" },
      { prop: "statusLabel", label: "状态", status: true },
    ],
    form: [
      { key: "title", label: "公告标题", required: true },
      {
        key: "type",
        label: "通知类型",
        type: "select",
        options: [
          { label: "机构公告", value: "organization" },
          { label: "班级通知", value: "class" },
          { label: "缴费通知", value: "payment" },
          { label: "放假通知", value: "holiday" },
        ],
      },
      {
        key: "scope",
        label: "接收范围",
        type: "select",
        options: [
          { label: "全体家长", value: "all" },
          { label: "指定班级", value: "class" },
          { label: "指定学生", value: "student" },
        ],
      },
      { key: "content", label: "正文内容", type: "textarea" },
    ],
    actionWidth: 200,
  },
  payments: {
    title: "缴费记录管理",
    description: "查看和管理本月及历史的所有收费详情",
    addText: "新增收费",
    addIcon: "el-icon-bank-card",
    exportable: true,
    filters: [
      {
        key: "keyword",
        label: "学生姓名",
        type: "input",
        placeholder: "输入学生姓名",
      },
      {
        key: "itemName",
        label: "收费项目",
        type: "input",
        placeholder: "输入收费项目",
      },
      {
        key: "status",
        label: "支付状态",
        type: "select",
        options: [
          { label: "已支付", value: "paid" },
          { label: "待支付", value: "pending" },
          { label: "欠费", value: "overdue" },
        ],
      },
      { key: "date", label: "收费日期", type: "date" },
    ],
    columns: [
      { prop: "studentName", label: "学生姓名", avatar: true },
      { prop: "itemName", label: "收费项目", width: 160 },
      { prop: "amount", label: "收费金额", money: true },
      { prop: "method", label: "支付方式" },
      { prop: "statusLabel", label: "支付状态", status: true },
      { prop: "date", label: "操作日期" },
    ],
    form: [
      {
        key: "studentId",
        label: "学生",
        type: "select",
        lookup: "students",
        required: true,
      },
      { key: "itemName", label: "收费项目", required: true },
      { key: "amount", label: "收费金额", type: "number", required: true },
      {
        key: "status",
        label: "支付状态",
        type: "select",
        options: [
          { label: "待支付", value: "pending" },
          { label: "已支付", value: "paid" },
          { label: "欠费", value: "overdue" },
        ],
      },
    ],
    actionWidth: 240,
  },
  users: {
    title: "员工管理",
    description: "管理教职员工、班主任及系统管理人员",
    addText: "新增员工",
    addIcon: "el-icon-user-solid",
    exportable: true,
    filters: [
      {
        key: "keyword",
        label: "姓名或手机号",
        type: "input",
        placeholder: "输入姓名或手机号",
      },
      {
        key: "role",
        label: "角色",
        type: "select",
        options: [
          { label: "老师", value: "teacher" },
          { label: "校区管理员", value: "campus_admin" },
          { label: "校长", value: "principal" },
        ],
      },
      {
        key: "status",
        label: "账号状态",
        type: "select",
        options: [
          { label: "启用中", value: "active" },
          { label: "已禁用", value: "disabled" },
        ],
      },
    ],
    columns: [
      { prop: "name", label: "姓名", avatar: true },
      { prop: "phone", label: "手机号", width: 140 },
      { prop: "roleLabel", label: "角色类型" },
      { prop: "department", label: "岗位/班级", width: 150 },
      { prop: "joined", label: "加入日期" },
      { prop: "statusLabel", label: "账号状态", status: true },
    ],
    form: [
      { key: "name", label: "员工姓名", required: true },
      { key: "phone", label: "手机号", required: true },
      {
        key: "role",
        label: "角色",
        type: "select",
        options: [
          { label: "老师", value: "teacher" },
          { label: "校区管理员", value: "campus_admin" },
          { label: "校长", value: "principal" },
        ],
      },
    ],
    actionWidth: 250,
  },
  operationLogs: {
    title: "操作日志",
    description: "查看系统关键操作记录，支持筛选和导出当前结果",
    addText: "",
    exportable: true,
    filters: [
      {
        key: "keyword",
        label: "关键词",
        type: "input",
        placeholder: "操作人/动作/备注",
      },
      {
        key: "resourceType",
        label: "业务模块",
        type: "select",
        options: [
          { label: "学生", value: "student" },
          { label: "学生管理", value: "students" },
          { label: "班级管理", value: "classes" },
          { label: "员工管理", value: "users" },
          { label: "请假审批", value: "leave" },
          { label: "通知公告", value: "notice" },
        ],
      },
      {
        key: "action",
        label: "操作类型",
        type: "input",
        placeholder: "输入 action",
      },
      {
        key: "result",
        label: "操作结果",
        type: "select",
        options: [
          { label: "成功", value: "success" },
          { label: "失败", value: "failed" },
        ],
      },
      { key: "startDate", label: "开始日期", type: "date" },
      { key: "endDate", label: "结束日期", type: "date" },
    ],
    columns: [
      { prop: "createdAtLabel", label: "操作时间", width: 170 },
      { prop: "operatorName", label: "操作人", width: 120 },
      { prop: "actionLabel", label: "操作类型", width: 170 },
      { prop: "resourceTypeLabel", label: "业务模块", width: 120 },
      { prop: "resourceName", label: "操作对象", width: 180 },
      { prop: "resourceId", label: "业务ID", width: 160 },
      { prop: "resultLabel", label: "结果", status: true, width: 90 },
      { prop: "remark", label: "操作说明", width: 260 },
      { prop: "ip", label: "IP地址", width: 140 },
    ],
    form: [],
    actionWidth: 0,
  },
};

BUSINESS_PAGES.leaves.exportable = true;
BUSINESS_PAGES.leaves.filters = BUSINESS_PAGES.leaves.filters.map((field) =>
  field.key === "date"
    ? { ...field, defaultValue: () => new Date().toISOString().slice(0, 10) }
    : field,
);
BUSINESS_PAGES.students.filters = BUSINESS_PAGES.students.filters.map((field) =>
  field.key === "status"
    ? {
        ...field,
        options: [
          { label: "在读", value: "active" },
          { label: "停托", value: "suspended" },
        ],
      }
    : field,
);
BUSINESS_PAGES.students.filters.push({
  key: "remainingDaysLte",
  label: "剩余天数",
  type: "select",
  options: [{ label: "不足 5 天", value: 5 }],
});

export function getBusinessPage(key, lookups) {
  const page = BUSINESS_PAGES[key] || BUSINESS_PAGES.students;
  const options = (field) =>
    field.lookup === "classes"
      ? lookups.classes.map((item) => ({ label: item.name, value: item.id }))
      : field.lookup === "teachers"
      ? lookups.teachers.map((item) => ({ label: item.name, value: item.id }))
      : field.lookup === "students"
      ? lookups.students.map((item) => ({ label: item.name, value: item.id }))
      : field.options || [];
  return {
    ...page,
    filters: page.filters.map((field) => ({
      ...field,
      options: options(field),
    })),
    form: page.form.map((field) => ({ ...field, options: options(field) })),
  };
}
